"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.internalTransactionResponseKeys = void 0;
exports.internalTransactionResponseKeys = [
    '_processor',
    'accountNumber',
    'accountType',
    'approvalNumber',
    'approvedAmount',
    'balanceAmount',
    'cardLogo',
    'cashbackAmount',
    'convenienceFeeAmount',
    'currencyCode',
    'debitSurchargeAmount',
    'ebtType',
    'emv',
    'entryMode',
    'isApproved',
    'merchantId',
    'networkLabel',
    'paymentType',
    'subTotalAmount',
    'terminalId',
    'tipAmount',
    'totalAmount',
    'transactionDateTime',
    'pinVerified',
    'language',
];
//# sourceMappingURL=internalSaleResponseKeys.js.map